import type { Percent } from './Percent';

export class ElectricLoad {
  readonly unit: '%' = '%' as const;
  private value: number;
  constructor(loading: number) {
    this.value = loading;
  }

  static fromPercent(loading: Percent) {
    return new ElectricLoad(loading.asFraction());
  }

  toString() {
    return `${(this.value * 100).toFixed(2)} ${this.unit}`;
  }
}
